import { Form } from "react-bootstrap";

const Input = (props:any) => {
    return <>
        <Form.Control {...props}/>
        {props.label && <p className={props.error === true? "input-err": "input-info"}>{props.label}</p>}
    </>
}

export default Input;